<div *ngIf="idIsUserProvided">
    <h3>Download File</h3>
    <div>
        <div fxFlexFill>
            <div class="form-group required">
                <label for="downloadDocumentId">Document ID</label>
                <input type="text" class="form-control" [(ngModel)]="downloadDocumentId"
                    name="downloadDocumentId" />
            </div>
        </div>
    </div>
    <div>
        <div fxFlexFill>
            <div style="text-align:center;">
                <button class="btn btn-primary"
                    (click)="downloadDocument(downloadDocumentId)">Download</button>
            </div>
        </div>
    </div>
</div>
<div *ngIf="!idIsUserProvided">
    <div>
        <div fxFlexFill>
            <div style="text-align:center;">
                <button class="btn btn-primary"
                    (click)="downloadDocument(downloadDocumentId)">Download</button>
            </div>
        </div>
    </div>
</div>